import { createSlice } from "@reduxjs/toolkit"

export const accountinfoSlice = createSlice({
  name: "accountinfo",
  initialState: null,
  reducers: {
    set: (state, action) => action.payload
  }
})

export const { set: setAccountInfo } = accountinfoSlice.actions

export default accountinfoSlice.reducer
